export enum PubSub {
  Ticket = 'ticket',
  Settings = 'settings',
}
